export const INITIAL_STATE = {
  hours: {
    open: false,
    nextTiming: null,
    schedule: null,
    loading: false,
  },
};
